<script setup lang="ts">
import InviteTeammateDialog from './dialogs/InviteTeammateDialog.vue'
import UpdateEmployerCompanyAccessDialog from './dialogs/UpdateEmployerCompanyAccessDialog.vue'
import { useConfirm } from 'primevue/useconfirm'
import { DeleteEmployerTeammateType, ListOtherEmployersForCompanyEmployer } from '@swipe4work/models-orval'
import { deleteTeammate } from '@swipe4work/api-orval'
import TeammatesContent from './components/TeammatesContent.vue'

definePage({
  name: '/settings/Teammates',
  path: '/instellingen/teamgenoten',
  meta: {
    layout: 'false',
  },
})

const companyStore = useCompanyStore()
const authStore = useAuthStore()
const { userId } = storeToRefs(authStore)
const { company, employers } = storeToRefs(companyStore)

const { t } = useI18n()
const confirm = useConfirm()
const dialog = useDynamicDialog()
const toast = useToast()

async function openInviteTeammateDialog() {
  dialog.open(InviteTeammateDialog, {
    props: {
      dismissableMask: true,
      style: {
        width: 'fit-content',
        height: 'auto',
      },
    },
  })
}

async function openDeleteTeammateDialog(type: DeleteEmployerTeammateType, deleteUserId: number) {
  confirm.require({
    target: document.body,
    modal: true,
    message: t('settings.teammates.deleteTeammateMessage'),
    header: t('settings.teammates.deleteTeammateTitle'),
    accept: async () => {
      deleteTeammate({
        id: deleteUserId,
        type: type,
      })
        .then(() => {
          toast.success(t('settings.teammates.deleteTeammateSuccess'))
          companyStore.fetchEmployersInCompany()
        })
        .catch(error => {
          toast.error(t('settings.teammates.deleteTeammateFailed'))
          throw error
        })
    },
    acceptLabel: t('confirm'),
    rejectLabel: t('cancel'),
  })
}

async function openUpdateEmployerCompanyAccessDialog(employer: ListOtherEmployersForCompanyEmployer) {
  dialog.open(UpdateEmployerCompanyAccessDialog, {
    props: {
      dismissableMask: true,
      style: {
        width: 'fit-content',
        height: 'auto',
      },
    },
    data: {
      employer,
    },
  })
}

const hasChildCompanies = computed(() => {
  return (company.value?.childCompanies?.length || 0) > 0
})
</script>

<template>
  <TeammatesContent
    :employers="(employers as ListOtherEmployersForCompanyEmployer[])"
    :company-name="company?.name"
    :user-id="userId"
    :has-child-companies="hasChildCompanies"
    @invite="openInviteTeammateDialog"
    @delete="openDeleteTeammateDialog"
    @assign-to-child-companies="openUpdateEmployerCompanyAccessDialog"
  />
</template>
